import {
  FETCH_CITIES_DATA,
  FETCH_STATES_DATA,
  RESET_CITIES_DATA,
  FETCH_APPLICABLE_STATES,
  FETCH_APPLICABLE_CITIES,
  RESET_STATES_DATA,
  FETCH_COUNTRIES_DATA,
  RESET_COUNTRIES_DATA,
  FETCH_STATES_DATA_BY_COUNTRY,
  FETCH_OTHER_COUNTRIES_DATA,
  FETCH_OTHER_STATES_DATA_BY_COUNTRY,
  FETCH_OTHER_CITIES_DATA,
  RESET_OTHER_CITIES_DATA,
  RESET_OTHER_STATES_DATA_BY_COUNTRY,
  RESET_OTHER_COUNTRIES_DATA,
} from "../../constants/action.constants";

const initialState = {
  countries: [],
  states: [],
  cities: [],
  otherCountries: [],
  otherStates: [],
  otherCities: [],
  applicableStates: [],
  applicableCities: [],
};

const statesCitiesDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COUNTRIES_DATA:
      return { ...state, countries: action.payload, states: [], cities: [] };
    case FETCH_STATES_DATA_BY_COUNTRY:
      return { ...state, states: action.payload, cities: [] };
    case FETCH_STATES_DATA:
      return { ...state, states: action.payload, cities: [] };
    case FETCH_CITIES_DATA:
      return { ...state, cities: action.payload };
    case RESET_COUNTRIES_DATA:
      return { ...state, countries: [] };
    case RESET_CITIES_DATA:
      return { ...state, cities: [] };
    case RESET_STATES_DATA:
      return { ...state, states: [] };

    case FETCH_OTHER_COUNTRIES_DATA:
      return {
        ...state,
        otherCountries: action.payload,
        otherStates: [],
        otherCities: [],
      };
    case FETCH_OTHER_STATES_DATA_BY_COUNTRY:
      return { ...state, otherStates: action.payload, otherCities: [] };
    case FETCH_OTHER_CITIES_DATA:
      return { ...state, otherCities: action.payload };
    case RESET_OTHER_COUNTRIES_DATA:
      return {
        ...state,
        otherCountries: [],
      };
    case RESET_OTHER_STATES_DATA_BY_COUNTRY:
      return { ...state, otherStates: [] };
    case RESET_OTHER_CITIES_DATA:
      return { ...state, otherCities: [] };

    case FETCH_APPLICABLE_STATES:
      return { ...state, applicableStates: action.payload };
    case FETCH_APPLICABLE_CITIES:
      return { ...state, applicableCities: action.payload };
    default:
      return state;
  }
};

export default statesCitiesDataReducer;
